"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountType = void 0;
var AccountType;
(function (AccountType) {
    AccountType["CHECKING"] = "CH";
    AccountType["Four01K"] = "FO";
    AccountType["SAVINGS"] = "SA";
    AccountType["RETIREMENT"] = "RE";
    AccountType["INVESTMENT"] = "IN";
    AccountType["LIFE_INSURANCE"] = "LI";
    AccountType["SALEPROCEEDS"] = "SP";
    AccountType["STOCKS_BONDS"] = "ST";
    AccountType["GIFT"] = "GI";
    AccountType["EARNEST_MONEY"] = "EM";
    AccountType["OTHER"] = "OT";
})(AccountType = exports.AccountType || (exports.AccountType = {}));
